import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=c628b582&scoped=true&"
import script from "./feed.vue?vue&type=script&lang=js&"
export * from "./feed.vue?vue&type=script&lang=js&"
import style0 from "./feed.vue?vue&type=style&index=0&id=c628b582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c628b582",
  null
  
)

export default component.exports